import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import * as formik from "formik";
import { Heading, T } from "../components/helpful";
import * as yup from "yup";
import $ from "jquery";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { encode as base64_encode } from "base-64";
import { Toast } from "primereact/toast";
import {link} from '../config';


/* The ChangePassword class in JavaScript handles the functionality for changing a user's password,
including form validation and API calls. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/

export default class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: <T value={"Change password"} />,
      desc: "",

      initialValues: {
        userID: this.props.user.userID,
        username: this.props.user.user_login_name,
        password: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
    this.showStatusMsg = this.showStatusMsg.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validPassword = this.validPassword.bind(this);
  }

  componentDidMount() {
    $("#new-password").on("input", this.validPassword);
  }

  componentWillUnmount() {
    $("#new-password").off("input", this.validPassword);
  }

  onSubmit = (values) => {
    fetch(link+"password_reset", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "*/*",
      },
      body: new URLSearchParams({
        username: base64_encode(values.username),
        password: base64_encode(values.password),
        newPassword: base64_encode(values.newPassword),
        userID: base64_encode(values.userID),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          this.showStatusMsg(true, "Password changed successfully.");
        } else {
          this.showStatusMsg(false, data.error);
         
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  subHeading = () => {
    return <>{this.state.desc}</>;
  };

  validPassword = (e) => {
    e.preventDefault();
    let val = e.target.value;

    if (/[A-Z]/.test(val)) {
      $(".valid-uppercase").addClass("text-success");
    }
    if (/[a-z]/.test(val)) {
      $(".valid-lowercase").addClass("text-success");
    }
    if (/[0-9]/.test(val)) {
      $(".valid-digit").addClass("text-success");
    }
    if (/[!@#$%^&*()_]/.test(val)) {
      $(".valid-character").addClass("text-success");
    }
    if (/^.{8,}$/.test(val)) {
      $(".valid-minimum").addClass("text-success");
    }
  };

  showStatusMsg(status, msg) {
    if (status) {
      this.toast.show({
        severity: "success",
        detail: msg,
        life: 3000,
        sticky: true,
      });
    } else {
      this.toast.show({
        severity: "error",
        detail: msg,
        life: 3000,
        sticky: true,
      });
    }
  }

  render() {
    const { Formik } = formik;

    const schema = yup.object().shape({
      username: yup.string().required(<T value={"Username is required"} />),
      password: yup
        .string()
        .required(<T value={"Current Password is required"} />),
      newPassword: yup
        .string()
        .required()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_])[A-Za-z\d!@#$%^&*()_ ]{8,}$/,
          "Password must meet validation criteria"
        )
        .required(<T value={"New Password is required"} />),
      confirmPassword: yup
        .string()
        .oneOf(
          [yup.ref("newPassword"), null],
          <T value={"Passwords must match"} />
        )
        .required(<T value={"Password confirmation is required"} />),
    });

    const popover = (
      <Popover id="popover-basic">
        <Popover.Header as="h3">
          <T value={"Validation Criteria"} />
        </Popover.Header>
        <Popover.Body className="fs-6">
          <p>
            <T value={"The New Password must contain"} />
          </p>
          <ul>
            <li className="valid-uppercase to-valid">
              <T value={"At least one uppercase letter [A-Z]"} />
            </li>
            <li className="valid-lowercase to-valid">
              <T value={"At least one lowercase letter [a-z]"} />
            </li>
            <li className="valid-digit to-valid">
              <T value={"One digit [0-9]"} />
            </li>
            <li className="valid-character to-valid">
              <T value={"One special character [!@#$%^&*()_ ]"} />
            </li>
            <li className="valid-minimum to-valid">
              <T value={"Minimum eight characters in length"} />.
            </li>
          </ul>
        </Popover.Body>
      </Popover>
    );

    return (
      <div>
        <div>
          <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
        </div>
        <div className="main-content">
          <Formik
            validationSchema={schema}
            onSubmit={this.onSubmit}
            initialValues={this.state.initialValues}
          >
            {({
              handleSubmit,
              handleChange,

              values,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form className="form" noValidate onSubmit={handleSubmit}>
                <Toast
                  ref={(el) => (this.toast = el)}
                  position="bottom-right"
                />
               
                <Row>
                  <Col className="col-12 col-sm-6 col-lg-6 offset-md-3">
                    <h5 className="text-center">
                      {" "}
                      <T value={"Please sign in to continue"} />{" "}
                    </h5>

                    <FloatingLabel
                      label={<T value={"Username/email"} />}
                      className="mt-5 mb-2"
                    >
                      <Form.Control
                        type="text"
                        id="username"
                        placeholder="name@example.com"
                        name="username"
                        disabled
                        value={values.username}
                        onChange={handleChange}
                        isInvalid={!!errors.username}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.username}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                    <FloatingLabel
                      label={<T value={"Password"} />}
                      className="mb-2"
                    >
                      <Form.Control
                        type="password"
                        id="password"
                        placeholder={<T value={"Password"} />}
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        isInvalid={!!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                    <OverlayTrigger
                      trigger="click"
                      placement="right"
                      overlay={popover}
                    >
                      <FloatingLabel
                        label={<T value={"New Password"} />}
                        className="mb-2"
                      >
                        <Form.Control
                          type="password"
                          id="new-password"
                          placeholder={<T value={"New Password"} />}
                          name="newPassword"
                          value={values.newPassword}
                          onChange={handleChange}
                          isInvalid={!!errors.newPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.newPassword}
                        </Form.Control.Feedback>
                      </FloatingLabel>
                    </OverlayTrigger>
                    <FloatingLabel
                      label={<T value={"Confirm Password"} />}
                      className="mb-2"
                    >
                      <Form.Control
                        type="password"
                        id="confirm-Password"
                        placeholder={<T value={"Confirm Password"} />}
                        name="confirmPassword"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        isInvalid={!!errors.confirmPassword}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.confirmPassword}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                    <button
                      type="submit"
                      className="col-12 my-4  btn  bcb-btn-primary bcb-btn-small text-uppercase "
                    >
                      {<T value={"Save"} />}
                    </button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}
